import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function LieSection() {
  return <section className="bg-[#0A0A0A] px-5 py-16 md:py-24" data-id="element-146">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-147">
        <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-8" data-id="element-148">
          La mentira más cara del afiliado:
        </motion.h2>

        <motion.p variants={itemVariants} className="text-2xl md:text-3xl text-[#E8732A] font-bold mb-8" data-id="element-149">
          "Necesito más seguidores."
        </motion.p>

        <motion.p variants={itemVariants} className="text-white text-xl md:text-2xl font-semibold mb-6" data-id="element-150">
          No.
        </motion.p>

        <motion.p variants={itemVariants} className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-8" data-id="element-151">
          Lo que necesitas es que la gente que{' '}
          <span className="text-white" data-id="element-152">ya te está viendo</span> tenga un camino
          corto hacia la compra.
        </motion.p>

        <motion.p variants={itemVariants} className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-8" data-id="element-153">
          En móvil,{' '}
          <span className="text-[#E8732A] font-semibold" data-id="element-154">
            cada paso extra mata intención.
          </span>
        </motion.p>

        <motion.div variants={itemVariants} className="bg-[#141414] p-6 md:p-8 rounded-lg border border-[#2A2A2A]" data-id="element-155">
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed mb-4" data-id="element-156">
            Y el paso extra más común es este:
          </p>
          <p className="text-white text-2xl md:text-3xl font-bold mb-4" data-id="element-157">
            "Link en la bio."
          </p>
          <p className="text-[#A0A0A0] text-lg md:text-xl leading-relaxed" data-id="element-158">
            No porque sea "malo".
            <br data-id="element-159" />
            Sino porque casi siempre es{' '}
            <span className="text-[#E8732A]" data-id="element-160">demasiado largo</span> para un
            comprador impulsivo.
          </p>
        </motion.div>
      </motion.div>
    </section>;
}